import { Play } from 'lucide-react';
import type { Track } from '../lib/catalog';
import { formatDuration } from '../lib/catalog';

type TrackRowProps = {
  track: Track;
  active: boolean;
  playing: boolean;
  onSelect: (track: Track) => void;
};

export default function TrackRow({ track, active, playing, onSelect }: TrackRowProps) {
  return (
    <button className={active ? 'library-track active' : 'library-track'} onClick={() => onSelect(track)}>
      <span className="library-track-icon">
        {active && playing ? <span className="mini-equalizer"><i /><i /><i /></span> : <Play size={13} fill="currentColor" />}
      </span>
      <span className="library-track-copy">
        <strong>{track.name}</strong>
        <span>{track.activity || track.mental_state || track.category}</span>
      </span>
      <span className="library-track-duration">{formatDuration(track.duration_seconds)}</span>
    </button>
  );
}
